import { z } from "zod";

export const getCheckoutOptimizationCustomer = {
  input: z.object({
    customerIdentifier: z.union([
      z.object({ id: z.string() }),
      z.object({ emailAddress: z.string() }),
      z.object({ phoneNumber: z.string() }),
    ]),
    /**
     * The store URL that is passed as a request header is the one that will
     * determine the team in the handler's context. That team should be used
     * if the team is needed.
     *
     * This param is unused, but still needs to be here for cache routing.
     */
    storeUrl_forCacheRoutingOnly: z.string(),
  }),
  output: z.object({ numberOfOrders: z.number(), tags: z.array(z.string()) }),
};

export type GetCheckoutOptimizationCustomerOutput = z.infer<
  typeof getCheckoutOptimizationCustomer.output
>;
